import { useEffect, useState } from "react";
import ErrorIcon from "./ErrorIcon";

type InputProps = {
  name: string;
  placeholder: string;
  value: string;
  type?: string;
  as?: "input" | "textarea";
  error?: string;
};

export default function Input({
  name,
  placeholder,
  value,
  type = "text",
  as: RenderElement = "input",
  error,
}: InputProps) {
  const [isFocus, setIsFocus] = useState(false);

  useEffect(() => {
    if(value.length === 0) {
        setIsFocus(false);
    }
  }, [value]);

  return (
    <div className="flex flex-col w-full relative">
      <div
        className={`relative bg-gray-body border-black/20 border-[1px] rounded-[5px] px-[14px] py-3 grow ${
          error ? "border-error/80" : ""
        } transition-colors`}
      >
        <RenderElement
          id={name}
          name={name}
          type={type}
          className={`text-tiny h-[18px] w-full flex items-center !p-0 focus:outline-none focus:ring-0 focus:border-blue-600 ${
            RenderElement.toString() === "textarea"
              ? "resize-none h-[76px]"
              : ""
          }`}
          // placeholder=" "
          onFocus={() => setIsFocus(true)}
          onChange={({ target }) => target.value && setIsFocus(true)}
          onBlur={({ target }) => !target.value && setIsFocus(false)}
          value={value}
        />
        <label
          htmlFor={name}
          className={`absolute rounded-[5px] text-black/80 flex items-center duration-300 transform top-[9px] origin-left
            ${
              isFocus
                ? "-translate-y-1/2 left-[13px] text-left scale-65 text-primary"
                : ""
            }
        `}
        >
          {placeholder}
        </label>
      </div>
      {error && (
        <>
          <span className="text-micro text-error absolute -bottom-[17px]">
            {error}
          </span>
          <ErrorIcon className="text-error/80 w-4 h-4 m-1 top-0 right-0 z-10 absolute animate-fadein" />
        </>
      )}
    </div>
  );
}
